const INVENTORY_REPORT_STATUS = {
    BEST_SELLING: "BEST_SELLING",
    LOW_DEMAND: "LOW_DEMAND",
    PRODUCT_NOT_SOLD: "PRODUCT_NOT_SOLD",
}

export default INVENTORY_REPORT_STATUS;